import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { LoginResponseDto } from "../interfaces/loginResponseDto";

interface LoginRequestProps {
  login: string;
  password: string;
}

export const login = (data: LoginRequestProps) =>
  axiosInstance.post<LoginResponseDto>(LIGIN_API_URL.logIn(), data);
